import React from 'react';
import { useSelectable } from '.';
import Icon from '../Icons/Icon';

const SelectBox = ({id}) => {
    const {isSelecting, toggleSelected, isSelected} = useSelectable();

    if (!isSelecting) {
        return null;
    }

    return <Icon size="2x" icon={isSelected(id) ? 'SquareCheck' : 'Square'} onClick={() => toggleSelected(id)} />
}

export default SelectBox;
